<!DOCTYPE html>
<html lang="en">

<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>การประเมินระบบสารสนเทศ คณะวิทยาศาสตร์ มหาวิทยาลัยบูรพา</title>
    <link rel="icon" href="https://webapp.sci.buu.ac.th/actionplans/buu-sci-brand.png" type="image/x-icon" height="16"
        width="16">
    <link href="https://fonts.googleapis.com/css2?family=Sarabun:wght@300&display=swap" rel="stylesheet">
    <link rel="stylesheet" href="https://webapp.sci.buu.ac.th/actionplans/template/dist/css/adminlte.min.css">
    <style>
        body {
            font-family: 'Sarabun', sans-serif;
            margin: auto;
        }
    </style>
</head>

<body style="background-color: #ffc10738;">
    <div class="container mt-3">
        <div class="row">
            <div class="col-md-12">
                <div class="card">

                    <div class="card-body">
                        <form (submit)="onSubmit($event)">
                        <div class="table-responsive
                            table-hover">
                            <table class="table table-bordered">
                                <thead class="text-nowrap">
                                    <tr class="bg-warning">
                                        <th colspan="7" class="text-center">
                                            แบบประเมินความพึงพอใจระบบสารสนเทศคณะวิทยาศาสตร์ <br />
                                            <span style="color: blue;">ระบบสารสนเทศภาระงานอาจารย์</span>
                                        </th>
                                    </tr>
                                    <tr class="text-center">
                                        <th rowspan="2" style="vertical-align: middle;">#</th>
                                        <th rowspan="2" style="vertical-align: middle;">เนื้อหา</th>
                                        <th colspan="5">ระดับความพึงพอใจ</th>
                                    </tr>
                                    <tr>
                                        <td class="text-center">มากที่สุด</td>
                                        <td class="text-center">มาก</td>
                                        <td class="text-center">ปานกลาง</td>
                                        <td class="text-center">น้อย</td>
                                        <td class="text-center">น้อยที่สุด</td>
                                    </tr>
                                </thead>
                                <tbody id="addchoice"></tbody>                                
                                <tr *ngFor="let item of choice; index as i">
                                    <th class="text-center">{{number+i}}</th>
                                    <td>{{item.name}}</td>
                                    <td class="text-center">
                                        <fieldset id="group{{i}}">
                                            <input type="radio" name="score{{i}}" id="score{{i}}" class="score"
                                            value="{{item._id}},5">
                                        </fieldset>                                        
                                    </td>
                                    <td class="text-center">
                                        <input type="radio" name="score{{i}}" id="score{{i}}" class="score"
                                            value="{{item._id}},4">
                                    </td>
                                    <td class="text-center">
                                        <input type="radio" name="score{{i}}" id="score{{i}}" class="score"
                                            value="{{item._id}},3">
                                    </td>
                                    <td class="text-center">
                                        <input type="radio" name="score{{i}}" id="score{{i}}" class="score"
                                            value="{{item._id}},2">
                                    </td>
                                    <td class="text-center">
                                        <input type="radio" name="score{{i}}" id="score{{i}}" class="score"
                                            value="{{item._id}},1">
                                    </td>
                                </tr>
                                <tbody>
                                    <tr>
                                        <td colspan="7">
                                            <strong>ข้อเสนอแนะเพิ่มเติม </strong>
                                            <textarea name="detail_other" id="detail_other" cols="30" rows="10"
                                                class="form-control"></textarea>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="row">
                            <div class="col-12 text-center">
                                <div class="btn-group" role="group" aria-label="Basic example">
                                    <a href="#"> <!-- ข้อมูลที่ต้องเปลี่ยน -->
                                        <button class="btn btn-danger" type="button">ยกเลิก</button>
                                    </a>
                                    <button class="btn btn-success" type="submit">ตกลง</button>
                                </div>
                            </div>
                        </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <script src="https://webapp.sci.buu.ac.th/actionplans/template/plugins/jquery/jquery.min.js"></script>
    <script src="https://webapp.sci.buu.ac.th/actionplans/template/plugins/jquery-ui/jquery-ui.min.js"></script>
    <script
        src="https://webapp.sci.buu.ac.th/actionplans/template/plugins/bootstrap/js/bootstrap.bundle.min.js"></script>
</body>

</html>